/*global gantt*/
import React, { Component } from "react";
import "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import '../../../asset/css/dhtml-gantt-custom.css';
//import '../../../../../node_modules/dhtmlx-gantt/codebase/sources/locale/locale_th'
//import '../node_modules/dhtmlx-gantt/codebase/ext/dhtmlxgantt_grouping'
import "../../../asset/js/dhtmlx-gantt/locale/locale_th.js";
import userIcon from '../../../asset/img/fa-user-o.png'
import carIcon from '../../../asset/img/fa-car.png'
import taskIcon from '../../../asset/img/fa-tasks.png'
import buildingIcon from '../../../asset/img/fa-building.png'

import * as _ from 'lodash';
import moment from 'moment';

export default class Gantt extends Component {

  ganttInstance = null;

  parseTasks() {
    this.clearAll();
    gantt.parse(this.props.tasks);
    this.setDateRange();
  }

  addNewTask(task) {
    gantt.addTask(task)
  }

  clearAll() {
    gantt.clearAll()
  }

  deleteTask(taskId) {
    gantt.deleteTask(taskId)
    gantt.render()
  }

  getTaskDate(date) {
    const formatFunc = gantt.date.date_to_str("%d/%m/%Y")
    return formatFunc(date)
  }

  updateIcon() {
    const baseStyle = `
      background-size: contain;
      width: 22px;
      height: 100%;
      margin-left: 10px;
      margin-right: 10px;
    `
    gantt.templates.grid_folder = (item) => {
      if (this.props.maxLevel === 3) {
        const icon =
          item.$level === 0
            ? buildingIcon
            : item.$level === 1
              ? carIcon
              : userIcon
        const bgImgStyle = `background-image:url(${icon});`
        const style = `${bgImgStyle}${baseStyle}`
        return `<div class='gantt_tree_icon' style='${style}'></div>`;
      }
      const icon =
        item.$level === 0
          ? userIcon
          : carIcon
      const bgImgStyle = `background-image:url(${icon});`
      const style = `${bgImgStyle}${baseStyle}`
      return `<div class='gantt_tree_icon' style='${style}'></div>`;
    };

    gantt.templates.grid_file = (item) => {
      const style = `
          background-image:url(${taskIcon});
          background-size: contain;
          width: 22px;
          height: 100%;
          margin-left: 10px;
          margin-right: 10px;
        `
      return `<div class='gantt_tree_icon gantt_file' style='${style}'"></div>`;
    };

    gantt.render()
  }

  setZoom(value) {
    switch (value) {
      case "Hours":
        gantt.config.min_column_width = 20;
        gantt.config.scale_unit = "day";
        gantt.config.date_scale = '%d %M %Y';
        gantt.config.scale_height = 60;
        gantt.config.subscales = [{ unit: "hour", step: 1, date: "%H" }];
        break;
      case "Days":
        gantt.config.min_column_width = 35;
        gantt.config.scale_unit = "week";
        gantt.config.date_scale = 'สัปดาห์ที่ %W / %Y';
        gantt.config.subscales = [
          { unit: "day", step: 1, date: "%D" },
          {unit: 'day', step: 1, date: '%d/%m'},
        ];
        gantt.config.scale_height = 60;
        break;
      case "Months":
        gantt.config.min_column_width = 70;
        gantt.config.scale_unit = "month";
        gantt.config.date_scale = '%F / %Y';
        gantt.config.scale_height = 60;
        gantt.config.subscales = [{ unit: "week", step: 1, date: "#%W" }];
        break;
      case "Years":
        gantt.config.min_column_width = 140;
        gantt.config.scale_unit = "year";
        gantt.config.date_scale = "%F";
        gantt.config.scale_height = 60;
        gantt.config.subscales = [{ unit: "month", step: 1, date: "#%m" }];
      default:
        break;
    }
  }

  shouldComponentUpdate(nextProps) {
    return (
      // this.props.zoom !== nextProps.zoom || this.props.tasks !== nextProps.tasks
        this.props.zoom !== nextProps.zoom
        // || !_.isEqual(this.props.filter_date, nextProps.filter_date)
    );
  }

  componentDidUpdate() {
    console.log('gantt update');
    gantt.render();
    gantt.refreshData();

    // gantt.parse(this.props.tasks);
  }

  /* getGrandParent(childId) {
    var parentId = gantt.getParent(childId);
    return (parentId) ? getGrandParent(parentId) : (childId);
  } */

  sortTask() {
    if (this.props.sortFunc !== 'undefined')
      gantt.sort(this.props.sortFunc)
  }

  template() {
    gantt.templates.task_text = function (start, end, task) {
      return `${task.name}`;
    };

    gantt.templates.task_class = (start, end, task) => {
      if (typeof this.props.maxLevel === 'undefined') return
      if (task.$level === this.props.maxLevel)
        return task.disabled ? "parent_task" : ""
      return "parent_task"
    };
    gantt.templates.task_row_class = function(item) {
      return gantt.config.scale_unit;
    };
    gantt.templates.task_cell_class = function (item, date) {

      if (date.getDay() == 0) {
        return "weekend";
      }
    };

    gantt.templates.grid_row_class = (start, end, task) => {
      if (typeof this.props.maxLevel === 'undefined') return

      if (task.$level === this.props.maxLevel) {
        // return ""
        return task.disabled ? "nested_task hidden_date" : "nested_task";
      } else {
        return "parent_task_side";
      }
      return "";
    };

    gantt.attachEvent('onBeforeTaskDisplay', this.props.onBeforeTaskDisplay);

    // gantt.attachEvent("onAfterTaskAdd", (id, task) => {
    //   if (this.props.onTaskUpdated) {
    //     this.props.onTaskUpdated(id, "inserted", task);
    //   }
    // });

    /* gantt.attachEvent("onAfterTaskUpdate", (id, task) => {
      if (this.props.onTaskUpdated) {
        this.props.onTaskUpdated(id, "updated", task);
      }
    }); */

    /* gantt.attachEvent("onAfterTaskDelete", id => {
      if (this.props.onTaskUpdated) {
        this.props.onTaskUpdated(id, "deleted");
      }
    }); */

    /* gantt.attachEvent("onAfterLinkAdd", (id, link) => {
      if (this.props.onLinkUpdated) {
        this.props.onLinkUpdated(id, "inserted", link);
      }
    }); */

    /* gantt.attachEvent("onAfterLinkUpdate", (id, link) => {
      if (this.props.onLinkUpdated) {
        this.props.onLinkUpdated(id, "updated", link);
      }
    }); */

    /* gantt.attachEvent("onAfterLinkDelete", (id, link) => {
      if (this.props.onLinkUpdated) {
        this.props.onLinkUpdated(id, "deleted");
      }
    }); */

    /* gantt.attachEvent("onLightboxButton", (button_id, node, e) => {
      switch (button_id) {
        case "add_template_btn":
          gantt.resetLightbox();
          gantt.hideCover();
          this.props.showTemplateModal();
          break;
        case "add_holder_btn":
          gantt.resetLightbox();
          gantt.hideCover();
          this.props.showHolderModal();
          break;
        default:
          break;
      }
    }); */
    gantt.attachEvent("onBeforeLightbox", id => {
      const task = gantt.getTask(id);
      if (task.$new) {
        // add new task
        if (typeof this.props.onShowAddTaskModal !== 'undefined') {
          const parentOfNewTaskId = gantt.getParent(task.id)
          this.props.onShowAddTaskModal(task, parentOfNewTaskId)
        }
        return false
      }
      // edit task
      const parentOfTaskId = gantt.getParent(task.id)
      this.props.onShowEditTaskModal(task, parentOfTaskId)
      return false
      /* if (task.isCompany || task.isParent) {
        this.props.showEditCompanyModal(id);
      } else {
        return true;
      } */
    });

    gantt.attachEvent('onError', function(errorMessage) {
      console.error(errorMessage);
      return true;
    });

    gantt.attachEvent("onAfterTaskDrag", (id, mode, e) => {
      //any custom logic here
      const task = gantt.getTask(id)
      console.log('onAfterTaskDrag mode:', mode)
      console.log('onAfterTaskDrag task:', task)
      if (mode === 'move')
        this.props.onDragTask(task, gantt.getParent(task.id))
      if (mode === 'resize')
        this.props.onResizeTask(task, gantt.getParent(task.id))
    });

    gantt.attachEvent("onTaskLoading", task => {
      task.isParent = task.isCompany;
      return true;
    });

    /* gantt.attachEvent("onBeforeParse", function () {
      gantt.clearAll();
    }); */

    gantt.form_blocks["select_duration"] = {
      render: sns => {
        return '<div class="dhx_cal_ltext" style="padding: 10px;" > <input type="number" id="input_durations" /></div>';
      },
      set_value: (node, value, task, section) => {
        node.childNodes[1].value = task.duration || "";
      },
      get_value: (node, task, section) => {
        return parseInt(node.childNodes[1].value);
      },
      focus: node => {
        const a = node.childNodes[1];
        a.focus();
      }
    };

    // gantt.config.open_tree_initially = true;
  }

  setDateRange() {
    let start_date = _.min(
        _.filter(
            _.map(this.props.tasks.data, 'start_date'),
            (i) => i && !isNaN(i)),
    );
    let end_date = _.max(
        _.filter(
            _.map(this.props.tasks.data, 'end_date'),
            (i) => i && !isNaN(i)),
    );
    if (this.props.filter_date) {
      if (this.props.filter_date.start_date) {
        start_date = this.props.filter_date.start_date;
      }
      if (this.props.filter_date.end_date) {
        end_date = this.props.filter_date.end_date;
      }
    }

    const start_date_text = moment(start_date).
        startOf('week').
        add(1, 'day').
        format('YYYY-MM-DD');
    const end_date_text = moment(end_date).
        endOf('week').
        add(1, 'day').
        format('YYYY-MM-DD');

    console.log('change display range', start_date_text, '-', end_date_text);

    gantt.config.start_date = start_date_text;
    gantt.config.end_date = end_date_text;
  }

  configure() {
    // gantt.config.static_background = true;
    gantt.config.smart_rendering = true;
    gantt.config.show_unscheduled = true;
    gantt.config.show_task_cells = false;
    gantt.config.branch_loading = true;
    gantt.config.smart_scales = true;
    // gantt.config.xml_date = '%Y-%m-%d %H:%i:%s';

    /**
     * Hide redbox error
     */
    gantt.config.show_errors = false;

    gantt.config.columns = [
      {
        name: "name",
        label: "ลูกค้า/ทะเบียน/ช่างซ่อม",
        width: "*",
        tree: true
      },
      { name: "end_date", label: "วันส่งงาน", align: "center", format: "" },
      { name: "duration", label: "ระยะเวลา", align: "center" },
      { name: "add", label: "", width: 44 }
    ];
    const holders = this.props.holders.map((data, index) => {
      return { key: data.name, label: data.name };
    });
    if (typeof this.props.task_template === 'undefined') return;
    const handleSelectTemplate = event => {
      const name = event.target.value;
      const obj = this.props.task_template.filter(d => d.name === name);
      if (obj.length === 1) {
        const data = obj[0];
        document.getElementById("input_durations").max = data.maxDuration;
      }
    };
    const opts = this.props.task_template.map((data, index) => {
      return { key: data.name, label: data.name };
    });
    gantt.config.lightbox.sections = [
      {
        name: "template",
        height: 22,
        map_to: "template",
        type: "select",
        options: opts,
        onchange: e => handleSelectTemplate(e)
      },
      {
        name: "task_name",
        height: 30,
        map_to: "name",
        type: "textarea",
        focus: true
      },
      {
        name: "description",
        height: 40,
        map_to: "description",
        type: "textarea"
      },
      { name: "holder", map_to: "holder", type: "select", options: holders },
      {
        name: "start_date",
        height: 40,
        type: "time",
        map_to: "start_date",
        single_date: true,
        year_range: [2559, 2580]
      },
      { name: "duration", type: "select_duration", map_to: "duration_amount" }
    ];

    gantt.config.buttons_left = [
      "dhx_save_btn",
      "dhx_cancel_btn",
      "add_template_btn",
      "add_holder_btn"
    ];
    gantt.config.buttons_right = ["dhx_delete_btn"];
    gantt.config.autosize = "y";
    gantt.config.autofit = true;
    gantt.config.open_tree_initially = true;
  }

  componentDidMount() {
    // gantt.config.autosize = "x";
    this.template();
    this.configure()
    gantt.init(this.ganttContainer);
    gantt.parse(this.props.tasks);
    // gantt.load(this.props.tasks);

    if (this.props.onGanttInit) {
      window.ganttInstance = this.ganttInstance = gantt;
      this.props.onGanttInit(this.ganttInstance);
    }
  }
  print = () => {
    gantt.exportToPDF();
  };

  render() {
    this.setZoom(this.props.zoom);
    this.setDateRange();
    return (
      <div
        ref={input => {
          this.ganttContainer = input;
        }}
        style={{ width: "100%", height: "100%" }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/workdoc/plan/Gantt.js